<template>
    <footer class="app__footer">
        <div class="app__footer__inner">
            <div class="app__footer__navigation" v-if="subnavItems.length > 0">
                <ul>
                    <subnav-destination v-for="navItem in subnavItems"
                                        :link="navItem"
                                        :key="navItem.key"
                                        class="app__footer__link" />
                </ul>
                <guest-consent class="app__footer__guest-consent" />
            </div>
            <div class="app__footer__copyright">
                <span class="app__footer__text"><i class="far fa-copyright" /> {{ year }} Parity Projects Ltd.</span>
                <app-sponsorship class="app__footer__sponsorship"
                                 :in-footer="true" />
                <app-policies v-if="isNotPolicy"
                              class="app__footer__policies" />
            </div>
        </div>
    </footer>
</template>

<script>

import AppPolicies from './app-policies'
import AppSponsorship from './app-sponsorship'
import GuestConsent from './guest-consent'
import SubnavDestination from '@/components/header/subnav-destination'
import SubnavItems from '@/components/subnav-items'

export default {
    mixins: [
        SubnavItems,
    ],

    computed: {
        isNotPolicy() {
            return !this.$route || !this.$route.path || !this.$route.path.includes('/policies/')
        },

        year() {
            return new Date().getFullYear()
        },
    },

    components: {
        AppPolicies,
        AppSponsorship,
        GuestConsent,
        SubnavDestination,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.app {
    @include element('footer') {
        z-index: z-index('footer');
        font-size: 0.9em;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        height: $footer-height-base;

        @include bp-min-small {
            position: static;
            height: auto;
        }

        @include element('inner') {
            padding: $base-gutter;

            @include bp-min-mid {
                margin: 0 auto;
            }

            @include bp-min-wider {
                width: $grid;
            }
        }

        @include element('navigation') {
            display: none;

            @include bp-min-small {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: $wide-gutter;
                margin-top: $base-gutter;
                margin-bottom: $base-gutter;
                padding-bottom: $base-gutter;
            }

            @include bp-min-mid {
                margin-top: $mid-gutter;
                margin-bottom: $mid-gutter;
                padding-bottom: $mid-gutter;
            }

            @include bp-min-wide {
                grid-template-columns: 2fr 3fr;
                margin-top: $wide-gutter;
                margin-bottom: $wide-gutter;
                padding-bottom: $wide-gutter;
            }

            ul {
                list-style-type: none;
                padding: 0;
                margin: 0;

                @include bp-min-mid {
                    column-count: 2;
                }
            }

            li {
                padding: $base-gutter 0;

                @include bp-min-mid {
                    padding: $mid-gutter 0;
                }
            }

            a {
                display: inline;
            }
        }

        @include element('sponsorship') {
            display: none;

            @include bp-min-mid {
                display: inline-block;
            }
        }

        @include element('policies') {
            display: none !important;

            @include bp-min-small {
                display: block !important;
            }
        }

        @include element('copyright') {
            display: flex;
            align-items: top;
            justify-content: space-between;

            @include bp-min-mid {
                flex-direction: row;
                flex-wrap: wrap;
            }
        }
    }
}

</style>
